<template>
  <div class="app-ident-method-select">
    <div v-if="isVideoIdentPossible || isStoreIdentPossible" class="ident-method-heading"><slot name="txtHeadline"></slot></div>
    <div v-if="isVideoIdentPossible"
          id="mnp-card-video"
          :class = "[selectedIdentMethod_ === 'video' ? 'active' : '']"
          class="card">
      <SimonModal
        :is-visible="showVideoInfoModal"
        @hide="showVideoInfoModal = false"
        size="large"
        :area-label-modal="getSlotText('areaLabelModalVideo', 'Weitere Informationen')"
      >
        <slot name="txtVideoModal"></slot>
      </SimonModal>
      <div class="content">
        <slot name="txtVideo">Video Karte</slot>
        <div class="text">
          <component :is="processedTag" :class="['h3']"><slot name="txtVideoHeadline">Video Karte Headline</slot></component>
          <div class="check-list"><slot name="txtVideoCheckList">Video Karte Check List</slot></div>
        </div>
        <div class="info-icon">
          <button @click="showVideoInfoModal=true" class="icon-only" type="button" aria-haspopup="dialog" :aria-label="getSlotText('infoIconVideoAriaLabel')">
            <img src="/files/flash/images/svg-icons/info-icon.svg" alt="">
          </button>
        </div>
      </div>
      <div class="button-box" v-if="!isSingleIdentMethod && selectedIdentMethod_ !== 'video'">
        <button type="button" @click="selectVideo" :aria-label="getSlotText('btnVideoAriaLabel')"><slot name="lblSelectCta"></slot></button>
      </div>
      <div class="active-info" v-else-if="selectedIdentMethod_ === 'video'" aria-live="polite" aria-label="Per Video-Anruf ausgewählt">
        <slot name="txtSelected"></slot><span class="icon-check"><img src="/files/flash/images/svg-icons/check-small.svg" width="20" height="20" /></span>
      </div>
    </div>
    <div v-if="isStoreIdentPossible" id="mnp-card-store"
         :class = "[selectedIdentMethod_ === 'store' ? 'active' : '']"
         class="card">
      <SimonModal
        :is-visible="showPostInfoModal"
        @hide="showPostInfoModal = false"
        size="large"
        :area-label-modal="getSlotText('areaLabelModalPost', 'Weitere Informationen')"
      >
        <slot name="txtStoreModal"></slot>
      </SimonModal>
      <div class="content">
        <slot name="txtStore">Store Karte</slot>
        <div class="text">
          <component :is="processedTag" :class="['h3']"><slot name="txtStoreHeadline">Store Karte Headline</slot></component>
          <div class="check-list"><slot name="txtStoreCheckList">Store Karte Check List</slot></div>
        </div>
        <div class="info-icon">
          <button @click="showPostInfoModal=true" :aria-label="getSlotText('infoIconPostAriaLabel')" class="icon-only" type="button" aria-haspopup="dialog">
            <img src="/files/flash/images/svg-icons/info-icon.svg" alt="">
          </button>
        </div>
      </div>
      <div class="button-box" v-if="!isSingleIdentMethod && selectedIdentMethod_ !== 'store'">
        <button type="button" @click="selectStore" :aria-label="getSlotText('btnPostAriaLabel')"><slot name="lblSelectCta"></slot></button>
      </div>
      <div class="active-info" v-else-if="selectedIdentMethod_ === 'store'" aria-live="polite" aria-label="In einer Postfiliale ausgewählt">
        <slot name="txtSelectedIdent">Ausgewählt</slot><span class="icon-check"><img src="/files/flash/images/svg-icons/check-small.svg" width="20" height="20" /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import validationFlow from '@/mixins/validators/validationFlow'
import beErrors from '@/mixins/beErrors'
import syncProperty from '@/mixins/syncProperty'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'IdentMethodSelect',
  data () {
    return {
      loading: false,
      showVideoInfoModal: false,
      showPostInfoModal: false
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    beErrors,
    syncProperty('selectedIdentMethod', 'selectedIdentMethod_')
  ],
  components: { SimonModal },
  props: {
    possibleIdentMethods: {
      type: Array
    },
    headline: {
      type: String,
      default: 'h2'
    }
  },
  methods: {
    selectStore () {
      this.selectedIdentMethod_ = 'store'
      this.$emit('after-button-click')
    },
    selectVideo () {
      this.selectedIdentMethod_ = 'video'
      this.$emit('after-button-click')
    }
  },
  computed: {
    isVideoIdentPossible: function () {
      return this.possibleIdentMethods.includes('video')
    },
    isStoreIdentPossible: function () {
      return this.possibleIdentMethods.includes('store')
    },
    isSingleIdentMethod: function () {
      if (this.possibleIdentMethods?.length === 1) {
        if (this.isVideoIdentPossible) {
          this.selectVideo()
        } else if (this.isStoreIdentPossible) {
          this.selectStore()
        }
        return true
      }
      return false
    },
    processedTag: function () {
      return this.headline
    }
  }
}
</script>
